import {api} from '../../../system/api';

export default {
    createShippingUser: (params) => api.post('shipping-users', {...params})
};
